export const PATHS = {
  ROOT: 'like',
  partTimeJobId: (partTimeJobId: number) =>
    `/part-time-jobs/${partTimeJobId}/${PATHS.ROOT}`,
};
